<div id="page-not-found-container" class="container-fluid">
    <div id="page-not-found-card">
        <!-- PIAS Logo -->
        <p>
            <img src="assets/images/PIAS-logo.png" alt="PIAS-logo" id="pias-logo" class="img img-fluid" />
        </p>
        <div class="page-caption">Page your are looking for is not found.</div>

        <button matButton="elevated" type="button" [routerLink]="'/login'" class="mt-4 py-4 px-5">
            <mat-icon>arrow_back</mat-icon> 
            Go to Login
        </button>
    </div>
</div>